var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMakeaNewOrderActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_3",
    fill: "#00966b",
    height: 512,
    viewBox: "0 0 64 64",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m60 1h-56a3 3 0 0 0 -3 3v56a3 3 0 0 0 3 3h56a3 3 0 0 0 3-3v-56a3 3 0 0 0 -3-3zm1 59a1 1 0 0 1 -1 1h-56a1 1 0 0 1 -1-1v-56a1 1 0 0 1 1-1h56a1 1 0 0 1 1 1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m56 8h-26a1 1 0 0 0 -1 1v5h-5a1 1 0 0 0 -1 1v6.7a12 12 0 1 0 0 22.6v10.7a1 1 0 0 0 1 1h26a1 1 0 0 0 1-1v-5h5a1 1 0 0 0 1-1v-40a1 1 0 0 0 -1-1zm-47 25a10 10 0 1 1 10 10 10.011 10.011 0 0 1 -10-10zm16 21v-10.623a11.974 11.974 0 0 0 0-20.754v-6.623h16v7a1 1 0 0 0 1 1h7v30zm18-36.586 4.586 4.586h-4.586zm12 30.586h-4v-25a1 1 0 0 0 -.293-.707l-8-8a1 1 0 0 0 -.707-.293h-11v-4h24z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m27 44h20v2h-20z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m27 48h20v2h-20z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m33 40h14v2h-14z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m33 36h14v2h-14z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m33 32h14v2h-14z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m33 28h14v2h-14z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m20 26h-2v6h-6v2h6v6h2v-6h6v-2h-6z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMakeaNewOrderActive);
export default __webpack_public_path__ + "static/media/MakeaNewOrderActive.0f5f1bf6c0e86b9064fba5e6aa7d692e.svg";
export { ForwardRef as ReactComponent };